var _path;
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.425 2h-8.867c-4.905 0-8.891 3.987-8.891 8.892v1.775a1.333 1.333 0 102.666 0v-1.775a6.23 6.23 0 016.225-6.225h8.876c3.433 0 6.233 2.798 6.233 6.242a6.248 6.248 0 01-3.18 5.437l-8.112 4.563a4.004 4.004 0 00-2.042 3.483v2.942a1.333 1.333 0 102.667 0v-2.942c0-.48.26-.926.68-1.162l8.115-4.565a8.915 8.915 0 004.539-7.756C33.334 5.995 29.342 2 24.425 2zm-5.758 30.667A2.666 2.666 0 1018.666 38a2.666 2.666 0 000-5.333z"
  })));
}
export default SvgQuestion;